import {DateTime} from 'luxon'

export const fmtDateIso = (dtStr: string) => {
    return DateTime.fromISO(dtStr).toLocaleString(DateTime.DATE_MED)
}